"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const polished_1 = require("polished");
exports.defaultSpacing = {
    1: '0.25rem',
    2: '0.5rem',
    3: '0.75rem',
    4: '1rem',
    5: '1.25rem',
    6: '1.5rem',
    8: '2rem',
    10: '2.5rem',
    12: '3rem',
    16: '4rem',
    20: '5rem'
};
exports.rounded = {
    sm: '0.25rem',
    md: '0.5rem',
    lg: '1rem',
    xl: '1.5rem',
    xxl: '2rem',
    full: '9999px'
};
exports.fontFamily = `Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'`;
exports.fontSize = {
    xs: '12px',
    sm: '15px',
    md: '18px',
    lg: '22px',
    xl: '24px',
    xxl: '28px'
};
exports.lineHeight = {
    sm: '1.2em',
    md: '1.4em',
    lg: '1.5em',
    xl: '2em'
};
exports.boxShadow = {
    sm: '0px 2px 2px rgba(0, 0, 0, 0.15)',
    md: '0px 4px 4px rgba(0, 0, 0, 0.15)',
    lg: '0px 8px 8px rgba(0, 0, 0, 0.15)'
};
exports.letterSpacing = {
    sm: '0.03rem',
    md: '0.05rem',
    lg: '0.07rem'
};
exports.colors = {
    black: '#2B2D34',
    blue: '#4a90e2',
    primary: {
        lighter: polished_1.lighten(0.3, '#4A90E2'),
        light: polished_1.lighten(0.1, '#4A90E2'),
        default: '#4A90E2',
        dark: polished_1.darken(0.1, '#4A90E2'),
        darker: polished_1.darken(0.3, '#4A90E2')
    },
    grey: {
        200: '#EFF0F3',
        300: '#DADFEC',
        600: '#555661',
        700: '#34363E'
    },
    white: '#ffffff',
    text: '#EFF0F3',
    highlight: '#4A90E2',
};
exports.default = {
    padding: exports.defaultSpacing,
    margin: exports.defaultSpacing,
    borderRadius: exports.rounded,
    colors: exports.colors,
    lineHeight: exports.lineHeight,
    fontSize: exports.fontSize,
    boxShadow: exports.boxShadow,
    letterSpacing: exports.letterSpacing,
    fontFamily: exports.fontFamily,
};
//# sourceMappingURL=default.js.map